export function mapTrueFalseToOptions (item, i) {
  return {
    id: i + 1,
    name: item,
    value: i === 0
  }
}
